import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { ICountryGroup } from '~/src/dash/api/console-api';
import { deleteCountryGroup } from '~/src/dash/api/country-group';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { ButtonV2, Div, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  region: ICountryGroup;
  handleSuccess: (deletedRegion: ICountryGroup) => void;
}

export const DeleteRegionDialog = ({ region, handleSuccess }: IProps) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const [isDeleteDisabled, setIsDeleteDisabled] = useState(false);

  const handleDelete = () => {
    if (isDeleteDisabled) return;
    setIsDeleteDisabled(true);
    deleteCountryGroup(region)
      .then(() => {
        unstable_batchedUpdates(() => {
          setIsDeleteDisabled(false);
          setError('');
          setOpen(false);
        });
        handleSuccess(region);
      })
      .catch((err) => {
        console.error(err);
        unstable_batchedUpdates(() => {
          setIsDeleteDisabled(false);
          setError('An error has occurred. Please wait and try again.');
        });
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ButtonV2
        onClick={handleClickOpen}
        backgroundColor={publicaColors.veryLightGray}
        hoverColor={publicaColors.lightGray}
        style={{ padding: spacing.small }}
      >
        <Div displayFlex>
          <IconV2 name='delete' large />
        </Div>
      </ButtonV2>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-delete-region'
        aria-describedby='alert-dialog-delete-region'
      >
        <DialogTitle id='alert-dialog-title'>Confirm Region Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {`Are you sure you want to delete the following region: ${region.Name}?`}
          </DialogContentText>
          {error && (
            <DialogContentText id='alert-dialog-error' style={{ color: publicaColors.red }}>
              {error}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDelete} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
